import { render, staticRenderFns } from "./ModalCustomer.vue?vue&type=template&id=703ff064&scoped=true&"
import script from "./ModalCustomer.vue?vue&type=script&lang=ts&"
export * from "./ModalCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCustomer.vue?vue&type=style&index=0&id=703ff064&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ff064",
  null
  
)

export default component.exports